<template>
    <div id="payment" class="p-[20px] rounded-[22px] mt-[18px]">
        <div class="flex justify-between">
            <div class="flex">
                <div class="flex items-center">
                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_1526_23336" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="41" height="41">
                            <rect width="41" height="41" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_1526_23336)">
                            <path
                                d="M36.7278 10.7757V30.2243C36.7278 31.0872 36.4288 31.8176 35.8309 32.4155C35.233 33.0135 34.5026 33.3124 33.6396 33.3124H7.35769C6.49475 33.3124 5.76432 33.0135 5.16641 32.4155C4.56849 31.8176 4.26953 31.0872 4.26953 30.2243V10.7757C4.26953 9.91272 4.56849 9.18229 5.16641 8.58438C5.76432 7.98646 6.49475 7.6875 7.35769 7.6875H33.6396C34.5026 7.6875 35.233 7.98646 35.8309 8.58438C36.4288 9.18229 36.7278 9.91272 36.7278 10.7757ZM6.83199 14.3566H34.1653V10.7757C34.1653 10.6442 34.1106 10.5237 34.0011 10.4142C33.8915 10.3047 33.7711 10.25 33.6396 10.25H7.35769C7.22626 10.25 7.10578 10.3047 6.99624 10.4142C6.88674 10.5237 6.83199 10.6442 6.83199 10.7757V14.3566ZM6.83199 19.81V30.2243C6.83199 30.3557 6.88674 30.4762 6.99624 30.5857C7.10578 30.6952 7.22626 30.75 7.35769 30.75H33.6396C33.7711 30.75 33.8915 30.6952 34.0011 30.5857C34.1106 30.4762 34.1653 30.3557 34.1653 30.2243V19.81H6.83199Z"
                                fill="#003765" />
                        </g>
                    </svg>
                </div>

                <div class="text-[20px] font-bold flex items-center ml-[4px]">การจ่ายเงิน</div>
                <button 
                    @click="navigateToPaymentPage" 
                    class="ml-2 px-2 py-1 bg-blue-100 text-blue-800 rounded-md text-xs hover:bg-blue-200 flex items-center"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                    ดูเพิ่มเติม
                </button>
            </div>
            <div class="flex">
                <div></div>
                <!-- <div class="icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.9 17.3L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.14583 12.3708 1.8875 11.1125C0.629167 9.85417 0 8.31667 0 6.5C0 4.68333 0.629167 3.14583 1.8875 1.8875C3.14583 0.629167 4.68333 0 6.5 0C8.31667 0 9.85417 0.629167 11.1125 1.8875C12.3708 3.14583 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L17.325 15.925C17.5083 16.1083 17.6 16.3333 17.6 16.6C17.6 16.8667 17.5 17.1 17.3 17.3C17.1167 17.4833 16.8833 17.575 16.6 17.575C16.3167 17.575 16.0833 17.4833 15.9 17.3ZM6.5 11C7.75 11 8.8125 10.5625 9.6875 9.6875C10.5625 8.8125 11 7.75 11 6.5C11 5.25 10.5625 4.1875 9.6875 3.3125C8.8125 2.4375 7.75 2 6.5 2C5.25 2 4.1875 2.4375 3.3125 3.3125C2.4375 4.1875 2 5.25 2 6.5C2 7.75 2.4375 8.8125 3.3125 9.6875C4.1875 10.5625 5.25 11 6.5 11Z"
                            fill="#003765" />
                    </svg>
                </div> -->
                <div class="flex justify-center items-center">
                    <input class="h-[40px] bg-[#F3F7FA] rounded-[12px]" placeholder="ค้นหาเลขห้อง" type="input"
                        v-model="filter.search" />
                </div>

            </div>
        </div>
        <div class="mt-[14px]" :class="filteredData.length > 5 ? 'table-container' : ''">
            <vs-table xl>
                <template #thead>
                    <vs-tr>
                        <vs-th >
                            เลขห้อง
                        </vs-th>
                        <vs-th class="text-[20px]" v-if="allBuilding">
                            ชื่อหอพัก
                        </vs-th>
                        <vs-th>
                            ลูกบ้าน
                        </vs-th>
                        <vs-th>
                            วันที่เข้าพัก
                        </vs-th>
                        <vs-th>
                            สถานะ
                        </vs-th>
                    </vs-tr>
                </template>
                <template #tbody>
                    <vs-tr :key="i" v-for="(tr, i) in filteredData" :data="tr">
                        <vs-td class="body-2 font-weight-bold">
                            {{ tr.RoomNumber }}
                        </vs-td>
                        <vs-td v-if="allBuilding">
                            {{ getBuildingName(tr) }}
                        </vs-td>
                        <vs-td>
                            {{ tr.user_sign_contract?.users_permissions_user
                                ?.firstName }} {{ tr.user_sign_contract?.users_permissions_user?.lastName }}
                        </vs-td>
                        <vs-td>
                            {{ convertDateNoTime(tr.createdAt) }}
                        </vs-td>
                        <vs-td>
                            <div class="flex items-center justify-start">
                                <div class=" w-[auto] pl-[12px] pr-[12px] rounded-[12px] pb-[4px] pt-[4px]"
                                    :class="getPaymentStatusClass(tr)">
                                    {{ getPaymentStatusLabel(tr) }} </div>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>
<script>
import { convertDateNoTime } from '@/components/hook/hook'
export default {
    props: {
        data: {
            type: Array,
            default: () => []
        },
        allBuilding: {
            type: Boolean,
            default: false,
        },
        childFunction2: {
            type: Function,
        },
        routeLink: {
            type: String,
            default: '/payment'
        },
    },
    data() {
        return {
            convertDateNoTime,
            filter: {
                select: [],
                checkSelect: [],
                search: '',
                floor: '',
                Id_card: ''
            },
        }
    },
    computed: {
        filteredData() {
            const keyword = (this.filter.search || '').toLowerCase().trim();
            if (!keyword) {
                return this.data;
            }
            return this.data.filter((item) =>
                String(item?.RoomNumber || '').toLowerCase().includes(keyword)
            );
        }
    },
    methods: {
        getBuildingName(room) {
            return (
                room?.room_building?.buildingName ||
                room?.user_sign_contract?.room?.room_building?.buildingName ||
                '-'
            );
        },
        hasTenant(room) {
            return !!room?.user_sign_contract?.users_permissions_user?.id;
        },
        getLatestBill(room) {
            const bills = room?.tenant_bills || [];
            if (!bills.length) {
                return null;
            }
            return bills.reduce((latest, bill) => {
                return new Date(bill.createdAt) > new Date(latest.createdAt) ? bill : latest;
            }, bills[0]);
        },
        getPaymentStatus(room) {
            if (!this.hasTenant(room)) {
                return 'VACANT';
            }

            const latestBill = this.getLatestBill(room);
            if (!latestBill) {
                return 'UNBILLED';
            }

            const rawStatus = latestBill.paymentStatus;
            if (rawStatus === 'Paid') return 'PAID';
            if (rawStatus === 'Waiting Review') return 'WAITING_REVIEW';
            if (rawStatus === 'In Review Progress') return 'IN_REVIEW_PROGRESS';
            if (rawStatus === 'Partial Paid') return 'PARTIAL_PAID';
            if (rawStatus === 'Not Paid') return 'UNPAID';

            return 'UNPAID';
        },
        getPaymentStatusLabel(room) {
            const status = this.getPaymentStatus(room);
            if (status === 'PAID') return 'ชำระแล้ว';
            if (status === 'WAITING_REVIEW') return 'รอตรวจสอบ';
            if (status === 'IN_REVIEW_PROGRESS') return 'กำลังตรวจสอบ';
            if (status === 'PARTIAL_PAID') return 'ชำระบางส่วน';
            if (status === 'VACANT') return 'ไม่มีผู้เช่า';
            if (status === 'UNBILLED') return 'ยังไม่ออกบิล';
            return 'ยังไม่ชำระ';
        },
        getPaymentStatusClass(room) {
            const status = this.getPaymentStatus(room);
            if (status === 'PAID') return 'bg-[#CFFBDA] text-[#0B9A3C]';
            if (status === 'WAITING_REVIEW') return 'bg-[#FFF2BC] text-[#D48C00]';
            if (status === 'IN_REVIEW_PROGRESS') return 'bg-[#E6F4FF] text-[#0B69C7]';
            if (status === 'PARTIAL_PAID') return 'bg-[#FFEBD6] text-[#C26A00]';
            if (status === 'VACANT') return 'bg-[#E5E7EB] text-[#4B5563]';
            if (status === 'UNBILLED') return 'bg-[#DBEAFE] text-[#1D4ED8]';
            return 'bg-[#FFE1E8] text-[#EA2F5C]';
        },
        navigateToPaymentPage() {
            // Use the routeLink prop if provided, otherwise use a default path
            const path = this.routeLink || '/payment';
            this.$router.push(path);
        },
        // async created() {
        //     this.attributes = await axios.get('user/get-profile?access-token=1');
        //     this.photo = await axios.get('photos?access-token=1');
        // },
    }
}
</script>
<style scoped>
tbody tr:nth-child(odd) {
  background-color: #c3d4f1;
  border-radius: solid !important;
}
tbody tr:nth-child(even) {
  background-color: #e3e5e9;
  border-radius: solid !important; 
}
th {
  font-size: 16px;
}
tbody td:first-child {
  font-size: 14px;
  width: 100;
}
tbody td {
  font-size: 14px;
}

/* th,td{
width:20px;
max-width:5px;
min-width:20px;
} */

#payment {
    background-color: rgb(255, 255, 255);
}

.icon {
    position: absolute;
    top: 20.2rem;
    left: 580px;
}

input[type=input] {
    padding-left: 32px;
    margin: 8px 0;
}

.table-container {
    height: 250px;
    /* Set a fixed height to enable scrolling */
    overflow-y: scroll;
    /* Enable vertical scrolling */
    padding: 10px;
    /* Optional: Add padding for spacing */
}

/* width */
::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #ffff;
    border-radius: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #E9EEF6;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #E9EEF6;
}
</style>